import { withTranslation } from '@modules/i18n_and_l10n/with_translation';
import { Bleed } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { Text } from '@visiba-cortex/react-ui-std';
import { BreakPoints, useBreakpoint } from '@cellula/react';
import styled from 'styled-components';
import { LinkInMessage } from '@components/link_in_message.component';

interface Props {
	textAboutUs: string;
}

const elements = {
	container: styled.div`
		display: flex;
		flex-direction: column;
		gap: ${tokens.spacing.x2};
		background-color: ${tokens.color.bg.surfaceBrand};
		padding: ${tokens.spacing.x4} ${tokens.spacing.x3};
		width: 100%;

		${tokens.breakpointQuery.small} {
			padding: ${tokens.spacing.x7} ${tokens.spacing.x9};
			border-radius: ${tokens.borderRadius.large};
		}
	`,
};

export function ReceptionHomeAboutUs({ textAboutUs, ...rest }: Props): JSX.Element {
	const breakpoint = useBreakpoint(BreakPoints.Small);

	return (
		<Bleed viewportWide={breakpoint as true /* TODO: need Cellula support to be able to pass in boolean and not just true lol */}>
			<elements.container {...rest}>
				<Text as='h3' font={tokens.text.heading.small}>
					{withTranslation('PW.Page.RH.AboutUs')}
				</Text>
				<Text font={tokens.text.body.regular} preserveLineBreaks>
					<LinkInMessage text={textAboutUs} />
				</Text>
			</elements.container>
		</Bleed>
	);
}
